import {
  CalendarMonth,
  CardMembership,
  Close,
  Dashboard,
  HowToReg,
  Info,
  Menu,
  NotificationsNone,
  ShoppingCartOutlined,
  VpnKey,
} from "@mui/icons-material";
import { Link, useLocation, useHistory } from "react-router-dom";
import React from "react";
import Action from "../../../components/Action/Action";
import MenuCheckOut from "../../../components/MenuCheckout/MenuCheckOut";
import { AuthContext } from "../../../context/auth/ApiContext";
import "./menubar.module.scss";
import "./menubar.module.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { settingContext } from "../../../context/Setting/Setting";
import { _deleteData, _retrieveData } from "../../../utils/local-storage";
import { ModalLayout } from "../../../components";
import importScript from "../../../effect/scriptHook";
import { authGetRequest } from "../../../api/laravel/public/api";
import moment from "moment";
import { EventInfo } from "../../Dashboard";
import { MenuHooks } from "../../../hooks/menuHooks.tsx";
import { showMenu } from "../../../utils/menu-mobile.tsx";


interface IMenuBar {
  loader: Boolean,
  handleCloseLoader: Event,
  menuIndex: String,
  setting: { app_name: "Learn with Lakeshore", logo: "" },
}

function MenuBar(props: IMenuBar) {
  const { menuIndex, loader, handleCloseLoader, setting } = props;
  const { user, inbox, event } = MenuHooks();
  const { logOut } = React.useContext(AuthContext);
  const [menuClass, setMenuClass] = React.useState<any>(null);
  const [meeting, setMeeting] = React.useState<any>(null);
  const [isModal, setModal] = React.useState<any>(false);

  const openMeetingLink = (meeting: Object) => {
    setMeeting(meeting);
    setModal(true);
  };
  const showMenu = (init: boolean = false, first: string | undefined | null = undefined, second: string = "none") => {
    const collectiond = document.getElementById("open_menu") as HTMLInputElement | null;

    if (!init) {
      if (collectiond)
        collectiond.classList.remove("toggle-active");
    }
    else {
      if (collectiond)
        collectiond.classList.add("toggle-active");
    }
    const searchBox = document.getElementById("search-box") as HTMLElement | null;
    const menu = document.getElementById("menu") as HTMLElement | null;
    if (searchBox && menu) {
      searchBox.style.display = second;
      menu.style.display = second;
    }
    setMenuClass(init);
  }

  const closeMessage = () => {
    alert('seyu')
   
  }

  return (
    <header id="header" className="header">
      <div className="container">
        {/* LOGO */}
        <Link
          className="logo px-2"
          to="/"
        >
          <img
            width={50}
            height={50}
            className="rounded mx-2"
            src={
              process.env.REACT_APP_LOCAL_FILE_PATH +
              "setting/small/" +
              setting?.logo
            }
          />
          <b className="font-bold primary-text uppercase text-base sm:text-xl md:text-2xl short_app_name">{setting?.app_name}</b>
        </Link>
        {/* END / LOGO */}
        {/* NAVIGATION */}
        <nav className="navigation">
          {!menuClass &&
            <div onClick={() => showMenu(true, "toggle-active", "block")} id="open_menu" className={`open-menu `}>
              <span className="item item-1" />
              <span className="item item-2" />
              <span className="item item-3" />
            </div>}
          {menuClass &&
            <div onClick={() => showMenu(false, undefined, "none")} id="open_menu" className={`open-menu `}>
              <span className="item item-1" />
              <span className="item item-2" />
              <span className="item item-3" />
            </div>}

          <ul id="menu" className={`menu`} >
            <li className={menuIndex === "home" ? "current-menu-item" : ""}><Link to="/">Home</Link></li>
            <li className={menuIndex === "acknowledge" ? "current-menu-item" : ""}>
              <Link to={"/acknowledgement"} className="cursor-pointer">Acknowledgement</Link>
            </li>
            <li className={menuIndex === "testimonial" ? "current-menu-item" : ""}>
              <Link to={"/testimonial"}>
                Testimonial
              </Link>
            </li>
            <li className={menuIndex === "courses" ? "current-menu-item" : ""}>
              <Link to="/courses">Courses</Link>
            </li>
            <li className={menuIndex === "help" ? "current-menu-item" : ""}>
              <Link to="/help">Help</Link>
            </li>
            <li className={menuIndex === "auth" ? "current-menu-item" : ""}>
              {!user && (
                <Link to={"/auth/login"}>
                  Login
                </Link>
              )}
              {user && (
                <Link to={"/student/home"}>
                  Dashboard
                </Link>
              )}
            </li>

          </ul>
          <div id="search-box" className="search-box">
            <i className="icon mdi mdi-magnify mdi2x" />
            <div className="search-inner">
              <form>
                <input type="text" placeholder="key words" />
              </form>
            </div>
          </div>
          {user && (
            <ul id="list-account-info" className="list-account-info">

              <li className="list-item messages">
                <div id="message-info" className="message-info item-click">
                  <i className="icon mdi mdi-email mdi2x" />
                  {inbox?.inbox?.data?.length > 0 && <span className="itemnew" />}
                </div>
                <div id="toggle-message" className="toggle-message toggle-list">
                  <div className="list-profile-title">
                    <h4>Inbox message</h4>
                    <span className="count-value">{inbox?.inbox?.data?.length}</span>
                    {/* <button onClick={()=>closeMessage()} className="cursor-pointer new-message"><i className="icon mdi2x mdi mdi-close" /></button> */}
                  </div>
                  <ul className="list-message">
                    {inbox?.inbox?.data?.map((item, index) => {
                      return (
                        <li key={index} className="ac-new">
                          <Link to="/student/inbox">
                            <div className="image">
                              <img src={
                                item?.send_by?.image
                                  ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + item?.send_by?.image
                                  : item?.send_by?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'
                              } alt="" />
                            </div>
                            <div className="list-body">
                              <div className="author">
                                <span>{item?.send_by?.first_name} {item?.send_by?.last_name}</span>
                                <div className="div-x" />
                              </div>
                              <p>{item?.description.slice(0, 20)}...</p>
                              <div className="time">
                                <span>{moment(item?.created_at).format("LL")}</span>
                              </div>
                              <div className="indicator">
                                {/* <i className="icon mdi1x mdi mdi-attachment" /> */}
                              </div>
                            </div>
                          </Link>
                        </li>
                      )
                    })}

                    {/* END / LIST ITEM */}
                  </ul>
                  <div className="viewall">
                    <Link to="/student/inbox">View more messages</Link>
                  </div>
                </div>
              </li>
              {/* END / MESSAGE INFO */}
              {/* NOTIFICATION */}
              <li className="list-item notification">
                <div id="notification-info" className="notification-info item-click">
                  <i className="icon mdi mdi-bell mdi2x" />
                  {event?.event?.length > 0 && <span className="itemnew" />}
                </div>
                <div id="toggle-notification" className="toggle-notification toggle-list">
                  <div className="list-profile-title">
                    <h4>Event List</h4>
                    <span className="count-value">{event?.event?.length}</span>
                    {/* <a className="cursor-pointer new-message"><i className="icon mdi2x mdi mdi-close" /></a> */}
                  </div>
                  <ul className="list-notification">
                    {/* LIST ITEM */}
                    {event?.event?.map((item, index) => (
                      <li key={index} className="ac-new">
                        <Link to="/student/calendar" className="cursor-pointer">
                          <div className="list-body">
                            <div className="author">
                              <span>{item.meeting?.title}</span>
                              <div className="div-x" />
                            </div>
                            <p></p>
                            <div className="image">
                              <i className="icon mdi2x mdi mdi-bell"></i>
                            </div>
                            <div className="time">
                              <span>{moment(item.start_date).format("LL")}</span>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))}
                    {event?.reminder?.map((item, index) => (
                      <li key={index} className="ac-new">
                        <a className="cursor-pointer" onClick={() => openMeetingLink(item?.meeting)} >
                          <div className="list-body">
                            <div className="author">
                              <span>{item?.course?.title}</span>
                              <div className="div-x" />
                            </div>
                            <p></p>
                            <div className="image">
                              <i className="icon mdi2x mdi mdi-calendar"></i>
                            </div>
                            <div className="time">
                              <span>{moment(item.start_date).format("LL")}</span>
                            </div>
                          </div>
                        </a>
                      </li>
                    ))}

                    {/* END / LIST ITEM */}
                  </ul>
                </div>
              </li>
              {/* END / NOTIFICATION */}
              <li className="list-item account">
                <div id="account-info" className="account-info item-click">
                  <img src={
                    user?.image
                      ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + user?.image
                      : user?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'
                  } alt="" />
                </div>
                <div id="toggle-account" className="toggle-account toggle-list">
                  <ul className="list-account">
                    <li><Link to="/student/profile"><i className="icon mdi1x mdi mdi-account" />Profile</Link></li>
                    <li><Link to="/auth/logout" className="cursor-pointer"><i className="icon mdi1x mdi mdi-logout" />Sign Out</Link></li>
                  </ul>
                </div>
              </li>
            </ul>
          )}
          {/* END / LIST ACCOUNT INFO */}
        </nav>
        {/* END / NAVIGATION */}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 100000 }}
          open={loader}
          onClick={handleCloseLoader}
        >
          <CircularProgress size={40}
            thickness={10} color="inherit" />
        </Backdrop>
        <ModalLayout
          modal={isModal}
          backgroundColor={"background.paper"}
          content={
            <>
              <EventInfo meeting={meeting} setModal={setModal} />
            </>
          }
        />
      </div>
    </header>
  );
}

export default MenuBar;
